import React, { Fragment, useCallback, useRef, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { any, isEmpty, map, prepend, propEq } from "ramda";
import { notBlank } from "../../../util/ext";
import { showSkeletons } from "../organizeUtil";

import Button from "@material-ui/core/Button";
import FilterListIcon from "@material-ui/icons/FilterList";
import Grid from "@material-ui/core/Grid";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    overflowX: "auto",
    overflowY: "hidden",
  },

  filterButton: {
    width: "auto",
  },

  menu: {
    borderRadius: "5px",
    boxShadow: "0px 0px 30px rgba(149, 169, 177, 0.3)",
    width: "200px",
  },

  menuLoading: {
    paddingLeft: 10,
  },

  startIcon: {
    marginLeft: 0,
  },

  selected: {
    color: theme.palette.primary.main,
    fontWeight: "bolder",
    "&:hover": {
      color: theme.palette.primary.main,
    },
  },

  selectedFilters: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: 22,
    width: 22,
    borderRadius: "20px",
    backgroundColor: theme.palette.primary.brandPrimary,
    color: "white",
    fontWeight: "bold",
    marginLeft: theme.spacing(1),
  },

  typeFacet: {
    textTransform: "capitalize",
    fontSize: "1.4rem",
  },
}));
const ContentTypeFiltersMenu = props => {
  const {
    contentTypes,
    contentTypeTerms,
    filterButtonText = "Filters",
    onContentTypeSelected,
    onClear,
    loading,
  } = props;

  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  const handleContentTypeSelected = useCallback(
    term => {
      onContentTypeSelected(term);
    },
    [onContentTypeSelected],
  );

  const handleClearContentTypes = useCallback(() => {
    onClear();
  }, [onClear]);

  return (
    <Fragment>
      <Button
        ref={anchorRef}
        onClick={() => setOpen(true)}
        color="primary"
        classes={{ root: classes.filterButton, startIcon: classes.startIcon }}
        style={{
          backgroundColor: open && "rgba(0, 0, 0, 0.04",
        }}
        startIcon={<FilterListIcon fontSize="large" />}
      >
        <Grid
          container
          wrap="nowrap"
          alignItems="center"
          style={{ textAlign: "left" }}
        >
          <Grid item style={{ fontWeight: "bold" }}>
            {filterButtonText}
          </Grid>
          {notBlank(contentTypeTerms) && (
            <Grid item>
              <div className={classes.selectedFilters}>
                {contentTypeTerms.length}
              </div>
            </Grid>
          )}
        </Grid>
      </Button>
      <Menu
        classes={{
          paper: classes.menu,
        }}
        style={{ paddingLeft: loading ? 5 : 0 }}
        anchorEl={anchorRef.current}
        open={open}
        onClose={() => setOpen(false)}
        transformOrigin={{
          horizontal: "right",
          vertical: "top",
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        getContentAnchorEl={null}
      >
        {loading
          ? showSkeletons(contentTypes.terms.length)
          : notBlank(contentTypes) &&
            map(
              term =>
                term.label === "All" ? (
                  <MenuItem
                    key={"content-type-facet-term-" + term.label}
                    className={clsx(classes.typeFacet, {
                      [classes.selected]: isEmpty(contentTypeTerms),
                    })}
                    variant="text"
                    onClick={handleClearContentTypes}
                  >
                    All
                  </MenuItem>
                ) : (
                  <MenuItem
                    key={"content-type-facet-term-" + term.label}
                    className={clsx(classes.typeFacet, {
                      [classes.selected]: any(
                        propEq("label", term.label),
                        contentTypeTerms,
                      ),
                    })}
                    variant="text"
                    onClick={() => handleContentTypeSelected(term)}
                  >
                    {term.count
                      ? `${term.label} (${term.count.toLocaleString()})`
                      : term.label}
                  </MenuItem>
                ),
              prepend({ label: "All" }, contentTypes.terms),
            )}
      </Menu>
    </Fragment>
  );
};

export default ContentTypeFiltersMenu;
